import { apiClient } from './api';

export type CollectionMethod = 'cash' | 'check' | 'mobile' | 'other';

export interface CashCollection {
  id: number;
  invoice_id: number;
  invoice_number: string | null;
  order_id: number | null;
  delivery_stop_id: number | null;
  driver_id: number;
  driver_name: string | null;
  customer_id: number | null;
  customer_name: string | null;
  amount: number;
  payment_method: CollectionMethod;
  reference_number: string | null;
  notes: string | null;
  amount_tendered: number | null;
  change_due: number | null;
  collected_at: string;
  created_at: string;
}

export interface CreateCollectionInput {
  // Provide either invoice_id, or order_id (invoice is found/created server-side).
  invoice_id?: number;
  order_id?: number;
  amount: number;
  payment_method?: CollectionMethod;
  delivery_stop_id?: number;
  reference_number?: string;
  notes?: string;
  collected_at?: string;
  /** Cash tendered by the customer (VP-DRV-003). Only meaningful for 'cash'. */
  amount_tendered?: number;
}

function unwrapList<T>(raw: any): T[] {
  if (Array.isArray(raw)) return raw as T[];
  if (Array.isArray(raw?.data)) return raw.data as T[];
  return [];
}

export async function recordCollection(input: CreateCollectionInput): Promise<CashCollection> {
  return apiClient.post<CashCollection>('/cash-collections', input);
}

export async function listMyCollections(from?: string, to?: string): Promise<CashCollection[]> {
  const raw = await apiClient.get<any>('/cash-collections/me', { from, to });
  return unwrapList<CashCollection>(raw);
}

export async function listAllCollections(filters: { driverId?: number; from?: string; to?: string } = {}): Promise<CashCollection[]> {
  const raw = await apiClient.get<any>('/cash-collections', filters as Record<string, any>);
  return unwrapList<CashCollection>(raw);
}
